import { boolean, number, object, optional, string } from 'valibot'

import {
  createSorterSchema,
  TRUCK_TYPES_SORT_KEYS
} from '@/features/shared/models'

export const TruckTypesSearchSchema = object({
  page: optional(number()),
  take: optional(number()),
  ...createSorterSchema(TRUCK_TYPES_SORT_KEYS),
  name: optional(string()),
  enable: optional(boolean())
})
